import React, { useState, useRef, useContext, useMemo } from 'react';

import { Tab, Tabs, TabPanel } from 'components/UI';

import { Box, Link } from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';
import i18n from 'i18n-js';
import { RulesetInputs } from './RulesetInputs';
import { initialValues, formSchema } from '../utils.jsx';
import { Formik } from 'formik';
import { UserContext } from 'context';
import { PaymentInputs } from './PaymentInputs';
import { useSelector } from 'react-redux';

export const RulesetTabs = ({ reservationRuleset }) => {
  const classes = {};
  const [tabIndex, setTabIndex] = useState(0);

  const formRef = useRef(null);

  const { orgType } = useContext(UserContext);
  const handleChange = (_, newIndex) => setTabIndex(newIndex);
  const user = useSelector((state) => state?.auth?.user || {});
  const paymentsEnabled = useSelector((state) => state.config.settings?.core?.receivable?.payments);

  const allowFullEdit = user?.role === 'superadmin';
  const initialValue = useMemo(
    () =>
      initialValues({
        id: reservationRuleset.id,
        ruleset: reservationRuleset,
        orgType,
        allowFullEdit,
        paymentsEnabled,
      }),
    [reservationRuleset, orgType, allowFullEdit, paymentsEnabled]
  );

  return (
    <>
      <Tabs value={tabIndex} onChange={handleChange}>
        <Tab label={i18n.t('reservation_rulesets.customers')} data-cy="customers-tab" />
        <Tab label={i18n.t('reservation_rulesets.non_customers')} data-cy="offline-tab" />
        {paymentsEnabled !== false && (
          <Tab label={i18n.t('reservation_rulesets.payments')} data-cy="payments-tab" />
        )}
      </Tabs>

      <Box style={{ fontSize: '12px', fontWeight: '400', marginTop: '22px', marginLeft: '25px' }}>
        <span style={{ color: '#007bff', fontWeight: '700', textDecoration: 'none' }}>{ i18n.t('reservation_rulesets.lmk_link_note')}</span> 
        { i18n.t('reservation_rulesets.lmk_link_body') }
        <Link
          href="https://knowledgebase.launchmobility.com/reservation-rulesets-rrs-overview?hs_preview=HBZoNmwp-185463447112"
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontWeight: '700' }}
        >
        {' '} { i18n.t('reservation_rulesets.lmk_link_text') }
        </Link>.
      </Box>
      
      <Box className={classes.tabContent}>
        <Formik
          initialValues={initialValue}
          validationSchema={formSchema(orgType)}
          enableReinitialize={true}
          innerRef={formRef}
          validateOnChange={false}
          validateOnBlur={false}
        >
          <SwipeableViews index={tabIndex}>
            <TabPanel value={tabIndex} index={0}>
              <RulesetInputs rule="driver_rules" editable={false} />
            </TabPanel>
            <TabPanel value={tabIndex} index={1}>
              <RulesetInputs rule="offline_rules" editable={false} />
            </TabPanel>
            {paymentsEnabled !== false && (
              <TabPanel value={tabIndex} index={2}>
                <PaymentInputs editable={false} />
              </TabPanel>
            )}
          </SwipeableViews>
        </Formik>
      </Box>
    </>
  );
};
